/**
 * Route for `campaign-dashboard`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignDashboardPage } from "../features/campaign-dashboard/CampaignDashboardPage";

export const campaignDashboardRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-dashboard",
	component: CampaignDashboardPage,
});

export default campaignDashboardRoute;
